<i18n>
en:
  font: '"SimHei", "Microsoft YaHei", "Heiti SC"'
ja:
  font: 'Noto Sans JP, 源ノ角ゴシック, Quicksand, 游ゴシック体, "Yu Gothic", YuGothic, "ヒラギノ角ゴシック Pro", "Hiragino Kaku Gothic Pro", メイリオ, Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif'
cn:
  font: 'Noto Sans, -apple-system, BlinkMacSystemFont, "Helvetica Neue", YuGothic, Hiragino Kaku Gothic ProN, Arial, Meiryo, sans-serif'
</i18n>

<template lang="pug">
  v-app#app(:style="{'font-family': $t('font')}")
    router-view
</template>

<script>
export default {
}
</script>

<style lang="sass">
$color-pack: false
@import '~vuetify/src/styles/main.sass'

*
  text-transform: none !important

.required
  label::after
    content: "*"
    margin-left: 4px
    font-weight: bold
    color: #ff6080
</style>
